import React from 'react';
import { Typography, makeStyles, Container } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  title:{
    marginTop: theme.spacing(2),
    fontSize: "16px",
    fontWeight: "500",
    backgroundColor: "white",
    borderRadius: "5px",
    width:"fit-content",
  }
}))

const TextPilih = (props) => {
  const classes= useStyles();
  return (
    <section id="text-pilih">
      <Container>
        <Typography
          variant="h6"
          className={classes.title}
        >
          {props.text}
        </Typography>
      </Container>
    </section>
  )
}

export default TextPilih
